export default "__VITE_ASSET__CUnmtuzA__"